export const appConfig = {
  availableLanguages: ['ru', 'kk', 'en'],
  defaultLanguage: 'ru',
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL
};
